var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 485.74 485.74",
    viewBox: "0 0 485.74 485.74",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m242.872 0c-134.14 0-242.868 108.736-242.868 242.864 0 134.14 108.728 242.876 242.868 242.876 134.136 0 242.864-108.736 242.864-242.876 0-134.128-108.728-242.864-242.864-242.864zm95.54 263.94-134.36 92.732c-16.776 11.588-30.584 4.248-30.584-16.316v-194.976c0-20.556 13.808-27.9 30.584-16.312l134.32 92.732c16.764 11.584 16.804 30.548.04 42.14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1ac0ea8c1933e5f2ee4dcec5f84290b2.svg";
export { ForwardRef as ReactComponent };